<script lang="ts" setup>

// Props
const props = withDefaults(defineProps<{
  showLanguageSelector?: boolean
}>(), {
  showLanguageSelector: true
})

// Idioma
const { locale, t } = useI18n()

const { loggedIn } = useUserSession()

const selectedIdioma = computed(() => locale.value)

</script>

<template>
  <header class="top-0 left-0 right-0 w-full h-16 z-50 backdrop-blur-lg transition shadow-xs sticky bg-white/80">
    <div class="px-4 py-4 mx-auto flex justify-between items-center h-full max-w-7xl">
      <div class="flex w-full items-center gap-4">

        <div class="sm:hidden">
          <UserZoneSidebar v-if="loggedIn" />
        </div>

        <div class="flex w-full items-center justify-between">

          <!-- Logo -->
          <NuxtLink :aria-label="$t('labels.aria.home')" :to="`/${locale}`">
            <Logo />
          </NuxtLink>

          <!-- Idioma -->
          <UPopover v-if="props.showLanguageSelector">
            <UButton size="xs" :class="['hover:no-underline']" :aria-label="$t('labels.aria.idiomaMoneda')" variant="link"
              color="neutral" :label="`${selectedIdioma.toUpperCase()}`" />
            <template #content>
              <div class="flex flex-col gap-2 p-5 pt-3">
                <div>
                  <p class="text-neutral-500 text-sm mb-1">{{ t('strapi.global.header.tituloIdioma') }}</p>
                  <LocaleSelector class="w-48" />
                </div>
              </div>
            </template>
          </UPopover>

        </div>

      </div>
    </div>
  </header>
</template>